var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("投保信息")]),_vm._v(" "),_c('Form',{ref:"form",staticClass:"mt15",attrs:{"model":_vm.form,"label-width":125}},[_c('FormItem',{attrs:{"label":"参保公司："}},[_vm._v("\r\n\t\t\t"+_vm._s(_vm.form.companyName)+"\r\n\t\t")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7ca8df6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/haierProduct/components/lineWork/common/applicant.vue
// module id = null
// module chunks = 